import { Row } from 'antd';
import DatePicker from './DatePicker';
import SettingConfigs from './SettingConfigs';
import styled from 'styled-components';
import Box from 'components/Box';
import AppointmentHint from './AppointmentHint';
import CustomerSearch from './CustomerSearch';
import CallerIdHistory from './CallerIdHistory';

const CalendarFilter = () => {
  return (
    <Container display='flex' flexDirection='column' alignSelf='stretch'>
      <CalendarFilterStyled className='CalendarFilterStyled' justify={'space-between'}>
        <DatePicker />
        <SettingConfigs />
      </CalendarFilterStyled>
      <Box display='flex' alignItems='center' alignSelf='stretch' gap='2' px='4' mt='1'>
        <CustomerSearch />
        <AppointmentHint />
        <CallerIdHistory />
      </Box>
    </Container>
  );
};

export default CalendarFilter;
const Container = styled(Box)``;
const CalendarFilterStyled = styled(Row)`
  padding: 0 1.5rem;
  background: #EAEDED;
  position: relative;
`;
